/* DESI'GN MADE – Bundle Builder für Focal.
   Eigenstaendig. Keine Theme-Abhaengigkeit ausser Focals dokumentierter Cart-API.
   Rabatt: ausschliesslich Shopify Automatic Discount "3 fuer 2". Hier wird KEIN Rabatt berechnet. */
(function () {
  "use strict";

  function euro(cents) {
    return (cents / 100).toLocaleString("de-DE", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }) + " €";
  }

  class DmBundleBuilder extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;

      /* Custom-Element-Upgrade kann vor dem Parsen der Kinder passieren.
         Dann spaeter erneut versuchen, statt an null zu scheitern. */
      if (!this.querySelector(".dm-bb-slots")) {
        if (document.readyState === "loading") {
          document.addEventListener("DOMContentLoaded", () => this.connectedCallback(), { once: true });
        } else {
          requestAnimationFrame(() => this.connectedCallback());
        }
        return;
      }

      this._ready = true;

      this.max = parseInt(this.dataset.slots, 10) || 3;
      this.selection = [];
      this.busy = false;

      this.slotList = this.querySelector(".dm-bb-slots");
      this.bar = this.querySelector(".dm-bb-progress-bar");
      this.countEl = this.querySelector(".dm-bb-count");
      this.sumEl = this.querySelector(".dm-bb-sum-value");
      this.cta = this.querySelector(".dm-bb-cta");
      this.errorEl = this.querySelector(".dm-bb-error");
      this.fullEl = this.querySelector(".dm-bb-full");

      this.addEventListener("click", this.onClick.bind(this));
      this.addEventListener("change", this.onChange.bind(this));
      this.render();
    }

    /* ---------- Auswahl ---------- */

    onChange(event) {
      const select = event.target.closest(".dm-bb-variant");
      if (!select) return;
      const card = select.closest(".dm-bb-card");
      this.setCardNote(card, "");
      const opt = select.options[select.selectedIndex];
      const priceEl = card.querySelector(".dm-bb-card-price");
      if (opt && opt.dataset.price && priceEl) {
        priceEl.textContent = euro(parseInt(opt.dataset.price, 10));
      }
    }

    onClick(event) {
      const add = event.target.closest(".dm-bb-add");
      if (add) {
        event.preventDefault();
        this.addFromCard(add.closest(".dm-bb-card"));
        return;
      }
      const remove = event.target.closest(".dm-bb-remove");
      if (remove) {
        event.preventDefault();
        this.removeAt(parseInt(remove.dataset.index, 10));
        return;
      }
      if (event.target.closest(".dm-bb-cta")) {
        event.preventDefault();
        this.submit();
      }
    }

    /* Liest die Variante IMMER frisch aus dem aktuellen Zustand der Karte. */
    readVariant(card) {
      const select = card.querySelector(".dm-bb-variant");
      if (select) {
        if (!select.value) {
          return { error: "Bitte zuerst eine Variante wählen." };
        }
        const opt = select.options[select.selectedIndex];
        if (!opt || opt.dataset.available === "false") {
          return { error: "Diese Variante ist ausverkauft." };
        }
        return {
          id: String(select.value),
          price: parseInt(opt.dataset.price, 10) || 0,
          title: card.dataset.title,
          variantTitle: opt.dataset.title || "",
          image: opt.dataset.image || card.dataset.image || ""
        };
      }
      if (card.dataset.available === "false" || !card.dataset.variantId) {
        return { error: "Dieses Produkt ist derzeit ausverkauft." };
      }
      return {
        id: String(card.dataset.variantId),
        price: parseInt(card.dataset.price, 10) || 0,
        title: card.dataset.title,
        variantTitle: "",
        image: card.dataset.image || ""
      };
    }

    addFromCard(card) {
      if (!card || this.busy) return;
      if (this.selection.length >= this.max) return;

      const v = this.readVariant(card);
      if (v.error) {
        this.setCardNote(card, v.error);
        return;
      }
      this.setCardNote(card, "");
      this.setError("");
      this.selection.push(v);
      this.render();
    }

    removeAt(index) {
      if (this.busy) return;
      if (index < 0 || index >= this.selection.length) return;
      this.selection.splice(index, 1);
      this.setError("");
      this.render();
    }

    setCardNote(card, message) {
      const note = card.querySelector(".dm-bb-card-note");
      if (!note) return;
      note.textContent = message || "";
      note.hidden = !message;
    }

    setError(message) {
      if (!this.errorEl) return;
      this.errorEl.textContent = message || "";
      this.errorEl.hidden = !message;
    }

    /* ---------- Darstellung ---------- */

    render() {
      const n = this.selection.length;
      const full = n >= this.max;

      /* Slots */
      const slots = this.slotList.querySelectorAll(".dm-bb-slot");
      slots.forEach((slot, i) => {
        const item = this.selection[i];
        slot.classList.toggle("is-filled", !!item);
        const media = slot.querySelector(".dm-bb-slot-media");
        const title = slot.querySelector(".dm-bb-slot-title");
        const variant = slot.querySelector(".dm-bb-slot-variant");
        const price = slot.querySelector(".dm-bb-slot-price");
        const btn = slot.querySelector(".dm-bb-remove");
        if (item) {
          media.innerHTML = item.image
            ? '<img src="' + item.image + '" alt="" loading="lazy" width="80" height="80">'
            : "";
          title.textContent = item.title;
          variant.textContent = item.variantTitle;
          variant.hidden = !item.variantTitle;
          price.textContent = euro(item.price);
          btn.hidden = false;
          btn.dataset.index = String(i);
          btn.setAttribute("aria-label", item.title + " aus dem Bundle entfernen");
        } else {
          media.innerHTML = "";
          title.textContent = "Produkt " + (i + 1) + " wählen";
          variant.textContent = "";
          variant.hidden = true;
          price.textContent = "";
          btn.hidden = true;
        }
      });

      /* Fortschritt */
      const pct = Math.min(100, Math.round((n / this.max) * 100));
      if (this.bar) {
        this.bar.style.setProperty("--dm-bb-width", pct + "%");
        this.bar.classList.toggle("is-complete", pct >= 100);
        const outer = this.bar.closest("[role=progressbar]") || this.bar;
        outer.setAttribute("aria-valuenow", String(n));
      }
      if (this.countEl) {
        this.countEl.textContent = n + " von " + this.max + " ausgewählt";
      }

      /* Zwischensumme – reine Summe, KEIN Rabatt */
      const total = this.selection.reduce((s, i) => s + i.price, 0);
      if (this.sumEl) this.sumEl.textContent = n ? euro(total) : "—";

      /* Karten sperren, wenn voll */
      this.querySelectorAll(".dm-bb-add").forEach((b) => {
        b.disabled = full || this.busy;
      });
      if (this.fullEl) this.fullEl.hidden = !full;

      /* CTA */
      if (this.cta) {
        this.cta.disabled = !full || this.busy;
        this.cta.textContent = this.busy
          ? "Wird hinzugefügt …"
          : "Bundle in den Warenkorb";
      }
    }

    /* ---------- Add to cart ---------- */

    submit() {
      if (this.busy) return;
      if (this.selection.length !== this.max) return;

      /* Varianten unmittelbar vor dem Request erneut validieren.
         Gleiche Variante wird zu EINER Position mit Menge zusammengefasst, damit die
         Cart-Antwort dieselbe Anzahl Positionen hat wie der Request (sonst meldet
         Shopifys shop_events_listener eine Abweichung und ein Pixel-Event geht verloren). */
      const mengen = new Map();
      for (const item of this.selection) {
        if (!item.id || !/^\d+$/.test(item.id)) {
          this.setError("Eine Auswahl ist ungültig. Bitte entferne sie und wähle erneut.");
          return;
        }
        mengen.set(item.id, (mengen.get(item.id) || 0) + 1);
      }
      const items = [];
      mengen.forEach((menge, id) => items.push({ id: Number(id), quantity: menge }));

      this.busy = true;
      this.setError("");
      this.render();

      fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
              ? window.Shopify.routes.root + "cart/add.js"
              : "/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "X-Requested-With": "XMLHttpRequest"
        },
        body: JSON.stringify({ items: items })
      })
        .then((response) =>
          response.json().then((data) => ({ ok: response.ok, status: response.status, data: data }))
        )
        .then((result) => {
          if (!result.ok || (result.data && result.data.status && result.data.status >= 400)) {
            const detail = (result.data && (result.data.description || result.data.message)) || "";
            const istDeutsch = /nicht verf|ausverkauft|nur noch|verfügbar|Lager/i.test(detail);
            const msg = istDeutsch
              ? detail
              : "Ein Produkt aus deinem Bundle ist gerade nicht verfügbar. Bitte entferne es und wähle ein anderes." +
                (detail ? " (" + detail + ")" : "");
            this.setError(msg);
            return;
          }

          /* Focals dokumentierte API – kein Purity Section Rendering */
          document.documentElement.dispatchEvent(
            new CustomEvent("cart:refresh", { bubbles: true })
          );
          const miniCart = document.getElementById("mini-cart");
          if (miniCart) {
            try { miniCart.open = true; } catch (e) { /* Drawer nicht verfuegbar */ }
          }

          this.selection = [];
          this.querySelectorAll(".dm-bb-card-note").forEach((n) => {
            n.textContent = "";
            n.hidden = true;
          });
        })
        .catch(() => {
          this.setError(
            "Verbindung zum Warenkorb fehlgeschlagen. Bitte prüfe deine Internetverbindung und versuche es erneut."
          );
        })
        .finally(() => {
          this.busy = false;
          this.render();
        });
    }
  }

  if (!customElements.get("dm-bundle-builder")) {
    customElements.define("dm-bundle-builder", DmBundleBuilder);
  }
})();
